import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "w-100 d-flex flex-column flex-sm-row align-items-center flex-nowrap",
  style: {"gap":"0.5rem"}
}
const _hoisted_2 = { style: {"min-width":"4rem","color":"var(--ch-blue-100)","font-size":"var(--font-xs)","font-weight":"500"} }
const _hoisted_3 = {
  class: "w-100 d-flex align-items-center",
  style: {"gap":"0 0.25rem"}
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LinearStepper',
  props: {
    steps: {},
    currentStep: {}
  },
  setup(__props: any) {

const props = __props;

const getStepStyle = computed(() => (step: number) => {
  let width;
  let backgroundColor = 'var(--ch-blue-100)';

  if (step < props.currentStep) {
    width = '100%';
  } else if (step === props.currentStep) {
    width = '50%';
  } else {
    width = '0%';
    backgroundColor = 'transparent';
  }

  return {
    width,
    backgroundColor,
    transitionDelay: step === props.currentStep ? '0.5s' : '0s'
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Step " + _toDisplayString(__props.currentStep) + " of " + _toDisplayString(__props.steps), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (step) => {
        return (_openBlock(), _createElementBlock("div", {
          key: step,
          class: "step-outer w-100",
          style: {"background-color":"var(--ch-sky-blue-50)"}
        }, [
          _createElementVNode("div", {
            class: "step-inner",
            style: _normalizeStyle(getStepStyle.value(step))
          }, null, 4)
        ]))
      }), 128))
    ])
  ]))
}
}

})